import { useState } from "react";
import DetailsDialog, { DetailsProps } from "../DetailsDialog";
import NumberInputField from "../ui/NumberInputField";
import TextInputField from "../ui/TextInputField";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const enum DensityType {
  Fixed = 'FIXED',
  Mixed = 'MIXED'
}

interface Material {
  name: string;
  density: number;
  unitPrice: number;
  kilogramPrice?: number;
  densityType?: DensityType;
}

const NAME_WITH_DENSITY_REGEX = /(?:T|HR|CM|CME|V|VISCO|VPTT|RG|N|PUR)[\W_]*(\d+)[\D]*/;

const MaterialDetails = (props: DetailsProps) => {
  const [name, setName] = useState<string>();
  const [density, setDensity] = useState<number>();
  const [unitPrice, setUnitPrice] = useState<number>();
  const [kilogramPrice, setKilogramPrice] = useState<number>();
  const [isDensityMixed, setDensityMixed] = useState<boolean>();

  const initializeFields = (data: Material) => {
    setName(data.name);
    setDensity(data.density);
    setUnitPrice(data.unitPrice);
    setKilogramPrice(data.kilogramPrice);
    setDensityMixed(data.densityType === DensityType.Mixed);
  };

  const setDensityIfNumber = (densityAsText: string) => {
    const density = Number(densityAsText);
    if (Number.isFinite(density)) {
      setDensity(density);
    }
  };

  const calculateAndSetDensity = (name: string) => {
    const match = name.match(NAME_WITH_DENSITY_REGEX);
    if (match) {
      setDensityIfNumber(match[1]);
    }
  };

  const handleNameChange = (name: string) => {
    setName(name);
    calculateAndSetDensity(name);      
  };

  const handleDensityMixedChanged
    = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => setDensityMixed(checked);

  const collectData = () => (name && density && unitPrice)
    ? {
        name,
        density,
        unitPrice,
        kilogramPrice,
        densityType: isDensityMixed ? DensityType.Mixed : DensityType.Fixed
      }
    : null;

  const renderFields = (initialData: Material|undefined) => (
    <>
      <h2>Wprowadź dane pianki poliuretanowej</h2>
      <TextInputField
        label='Nazwa'
        autoFocus
        initialValue={initialData?.name}
        onValueChange={handleNameChange}
      />
      <NumberInputField
        label='Gęstość [kg/m3]'
        initialValue={initialData?.density}
        calculatedValue={density}
        onValueChange={setDensity}
        />
      <NumberInputField
        label='Cena za centymetr [zł]'
        initialValue={initialData?.unitPrice}
        onValueChange={setUnitPrice}
      />
      <NumberInputField
        label='Cena za kilogram [zł]'
        initialValue={initialData?.kilogramPrice}
        onValueChange={setKilogramPrice}
      />
      <FormControlLabel
        label='Mix gęstości'
        control={<Checkbox
          checked={ isDensityMixed }
          onChange={ handleDensityMixedChanged }
        />}
      />
    </>
  );

  return (
    <DetailsDialog<Material>
      { ...props }
      resource='materials'
      renderFields={renderFields}
      initializeFields={initializeFields}
      collectData={collectData}
    />
  );
};
export default MaterialDetails;